import React, { useEffect, useState } from "react";
import Banner from "../../components/Banner";
import axios from "../../utils/request";
import { en, ch } from "../../utils/content";
import "./index.css";

const TalentsPage = () => {
  const [talents, setTalents] = useState<any>([]);
  useEffect(() => {
    const initData = async () => {
      const res: any = await axios.get("/index/recruit");
      if (res.code === 200) {
        setTalents(res.data.data);
      }
    };
    initData();
  }, []);
  const lang = sessionStorage.getItem("lang") || "ch";
  const TXT_INFO = lang === "en" ? en : ch;
  return (
    <div className="talents">
      <Banner />
      {talents?.length ? (
        talents?.map((item: any) => {
          return (
            <div className="li">
              <div className="title">{item.title}</div>
              <div dangerouslySetInnerHTML={{ __html: item.detail }} />
            </div>
          );
        })
      ) : (
        <div className="empty">{TXT_INFO.empty}</div>
      )}
    </div>
  );
};

export default TalentsPage;
